import {FormikProps} from 'formik';
import DotsLoading from '../../../../components/dotsLoading';
import {useGetInputGroupList} from '../../../../services/hookService';
import {ShowFormError} from '../../../../utilities/helper/showFormError';
import {InputGroupCodes} from '../../../../utilities/inputGroupCodes';
import {InputGroupItem} from './InputGroupItem';
import {IProductForm} from './productFormData';

interface Props {
  form?: FormikProps<IProductForm>;
  isEditing?: boolean;
}

const SelectInputGroup = ({form, isEditing}: Props) => {
  const {inputGroupList, isLoading} = useGetInputGroupList();

  const allowedCodes = [
    InputGroupCodes.FertilizerCode,
    InputGroupCodes.PesticideCode,
    InputGroupCodes.SeedsCode,
    InputGroupCodes.MachineryCode,
    InputGroupCodes.EquipmentCode,
  ];

  const filteredGroups = inputGroupList?.filter(group =>
    allowedCodes.includes(group.code),
  );

  return (
    <>
      <div
        className="text-gray-900 text-md"
        style={isEditing ? {pointerEvents: 'none', opacity: 0.6} : undefined}
      >
        <span>
          <p className="mb-1 font-medium color-gray-1 text-md">
            دسته محصول<span className="text-red-500">*</span>
          </p>

          {isLoading ? (
            <div className="grid place-content-center my-5">
              <DotsLoading />
            </div>
          ) : (
            <div className="grid grid-cols-4 gap-3 mt-4">
              {filteredGroups?.map((input, index) => (
                <InputGroupItem
                  key={index}
                  form={form}
                  code={input.code ?? 0}
                  image={input.image ?? ''}
                  title={input.title ?? ''}
                />
              ))}
            </div>
          )}
        </span>
      </div>

      <ShowFormError field="inputGroupCode" form={form} />
    </>
  );
};
export default SelectInputGroup;
